import axios from 'axios'
const util = require('../../util.js')

const default_filter = {
  application: null,
  category: null,
  message: null,
  lastSeenFrom: null,
  lastSeenTo: null,
}
const default_paging = {
  currentPage: 1,
  perPage: 25,
  perPageAlternatives: [25, 50, 100],
  totalRows: 0
}

const state = {
  eventLogs: [],
  filter: { ...default_filter },
  paging: { ...default_paging },
  applications: [],
  categories: [],
  loading: false
}

const mutations = {
  UPDATE_EVENTS (state, payload) {
    state.eventLogs = payload.response
    state.paging.totalRows = payload.resultCount
    },
  UPDATE_FILTER (state, payload) {
    state.filter = payload
    },
  UPDATE_PAGING (state, payload) {
    state.paging = payload
    },
  GET_APPLICATIONS (state, payload) {
    state.applications = payload
  },
  GET_CATEGORIES (state, payload) {
    state.categories = payload
  },
  UPDATE_FORM_DISABLE_INDICATOR (state, payload) {
    state.loading = payload
  }
}

const actions = {
  getEvents ({ commit }) {
    commit('UPDATE_FORM_DISABLE_INDICATOR', true)
    axios.get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/eventlog/', {
      params: {
        application: util.emptyToNull(state.filter.application),
        category: util.emptyToNull(state.filter.category),
        message: util.emptyToNull(state.filter.message),
        lastSeenFrom: util.dateToTimestamp(state.filter.lastSeenFrom),
        lastSeenTo: util.inclusiveDateTimestamp(state.filter.lastSeenTo),
        pageNumber: util.emptyToNull(state.paging.currentPage),
        pageSize: util.emptyToNull(state.paging.perPage)
      }
        }).then((response) => {
            commit('UPDATE_EVENTS', response.data)
        }).finally(() => {
      commit('UPDATE_FORM_DISABLE_INDICATOR', false)
    })
    },
  resetFilter ({ commit }) {
    commit('UPDATE_PAGING', { ...default_paging })
    commit('UPDATE_FILTER', { ...default_filter })
    },
  getApplications({ commit }){
    axios.get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/eventlog/applications')
         .then((response) => {
          commit('GET_APPLICATIONS', response.data)
        })
  },
  getCategories({ commit }){
    axios.get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/eventlog/categories')
         .then((response) => {
          commit('GET_CATEGORIES', response.data)
        })
  },
  getObjectReference(state, { objectReference }) {
    return axios
      .get(process.env.VUE_APP_INTERNAL_API_BASEURL + '/eventlog/' , {
        params:{
          objectReference: objectReference
        }
      })
      .then(response => response.data.response)
  }
}
const getters = {
  events: state => state.eventLogs,
  filter: state => state.filter,
  paging: state => state.paging,
  categories: state => state.categories,
  applications: state => state.applications,
  loading: state => state.loading
}

const eventsModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
export default eventsModule
